module.exports = __webpack_public_path__ + "static/media/side-bar.db3bbc20.png";